<div class="site-logo-double inline-flex-display top-padding-5 layout">
  <img src="assets/img/logo trm1 (1).svg" alt="Maryland State Retirement and Pension System" class="logo-img-style">
  <div class="block-display">
    <div> Employer </div>
    <div> Portal <span class="text-red" *ngIf="currentStage === '5'">(Sandbox)</span></div>
  </div>
</div>
<div class="common-bottom-border"></div>
<div class="row layout" id="middle-content">
  <div class="col s12 m12 l12 xl12 main-row">
    <div class="card outage-notice">
      <div class="card-content">
        <h4>{{outageTitle}}</h4>
        <div class="align-center">
          <img src="assets/img/Maryland crab.jpg" class="crab-img" alt="Maryland Crab">
          <div class="img-subtitle">
            <span>
              {{outageMessage}}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
